import { useRef, useEffect } from 'react';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
import { Link } from 'react-router-dom';
import slides from '../data/slides';

const HomeSliders = () => {
  
  const splideRef = useRef(null);

  useEffect(() => {
    if (splideRef.current) {
      new Splide(splideRef.current, {
        type: 'loop',
        perPage: 1,
        autoplay: true,
        interval: 6000,
        pauseOnHover: true,
        pauseOnFocus: true,
        pagination: false,
        arrows: false,
      }).mount();
    }
  }, []);

  return (
    <div className="mt-10">
      <div className="splide" ref={splideRef}>
        <div className="splide__track">
          <ul className="splide__list">
            {slides.map((slide, index) => (
              <li key={index} className="splide__slide relative">
                <img
                  src={slide.image}
                  className="w-full h-[65vh] object-cover rounded-lg"
                  alt={slide.title || `Slide ${index + 1}`}
                />
                {slide.title && slide.description && slide.buttonText && slide.buttonLink && (
                  <div className="absolute left-0 bottom-0 p-10">
                    <h2 className="text-3xl font-bold">{slide.title}</h2>
                    <p className="text-lg mt-2">{slide.description}</p>
                    <Link
                      to={slide.buttonLink}
                      className="mt-4 inline-block px-4 py-2 bg-red-700 rounded-full hover:bg-red-800"
                    >
                      {slide.buttonText}
                    </Link>
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="splide__progress">
          <div className="splide__progress__bar"></div>
        </div>
      </div>
    </div>
  );
};

export default HomeSliders;